import { render } from "./PlanNotYetSuccessComponent.vue?vue&type=template&id=f24ff490"
import script from "./PlanNotYetSuccessComponent.vue?vue&type=script&lang=js"
export * from "./PlanNotYetSuccessComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__